'use client';

import { useState, useRef, useCallback, useEffect } from 'react';

function useClearBtnControl(value) {
    var _a = useState('none'), initStatus = _a[0], setInitStatus = _a[1];
    var _b = useState(false), showClear = _b[0], setShowClear = _b[1];
    /**
     * Since blur trigger faster than user click on clear button so
     * this flag is prevent blur is trigger hidden before user click on it
     * */
    var allowHidden = useRef(true);
    var show = useCallback(function (status, inputValue) {
        switch (status) {
            case 'focus': {
                setInitStatus(status);
                if (inputValue !== '') {
                    setShowClear(true);
                }
                break;
            }
            case 'enter': {
                if (initStatus !== 'focus') {
                    if (inputValue !== '') {
                        setInitStatus(status);
                        setShowClear(true);
                    }
                }
                break;
            }
            case 'enter-clear': {
                allowHidden.current = false;
                setShowClear(true);
            }
        }
    }, [initStatus]);
    var hidden = useCallback(function (status) {
        switch (status) {
            case 'blur': {
                if (allowHidden.current) {
                    setInitStatus(status);
                    setShowClear(false);
                }
                break;
            }
            case 'leave': {
                if (initStatus !== 'focus' && allowHidden.current) {
                    setInitStatus(status);
                    setShowClear(false);
                }
                break;
            }
            case 'leave-clear': {
                allowHidden.current = true;
            }
        }
    }, [initStatus]);
    useEffect(function () {
        if (value === '') {
            allowHidden.current = true;
        }
    }, [value]);
    return {
        isShow: showClear && value !== '',
        show: show,
        hidden: hidden,
        status: initStatus
    };
}

export { useClearBtnControl as default };
//# sourceMappingURL=useClearBtnControl.js.map
